import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { HamburgerButton } from 'react-hamburger-button'
import { space, fontSizes } from 'config/theme'
import { COLORS, ROUTES } from 'config/constants'
import { scrollIntoView, pxToRem } from 'utils/helpers'
import { Flex } from 'components/atoms/Layout'
import Container from 'components/atoms/Container'
import Button from 'components/atoms/Button'
import Link from 'routes/components/Link'
import logo from 'assets/svg/logo-full.svg'

export const MENU_HEIGHT = pxToRem(80)

const Layout = styled.div`
  height: ${MENU_HEIGHT};
  overflow: hidden;
  background-color: ${COLORS.WHITE};
  border-bottom: solid 2px ${COLORS.WHITE_SMOKE};
`

const Logo = styled.img`
  width: ${pxToRem(150)};
  height: auto;
  max-height: 100%;
  object-fit: contain;
  object-position: left center;
  pointer-events: none;
`

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  padding-left: ${space.l};
  padding-right: ${space.l};
  font-size: ${fontSizes.s};
  line-height: 1;
  font-weight: bold;
  text-transform: uppercase;
`

const Header = ({ isMobileMenuOpen, onMobileMenuButtonClick }) => (
  <Layout>
    <Container.FullWidth height="100%">
      <Flex height="100%" justifyContent="space-between" py="m">
        <Flex flex="0 1 auto" minWidth="0" as={Link} to="/">
          <Logo src={logo} alt="NuNu" />
        </Flex>
        <Flex
          flex="none"
          my="auto"
          display={{ mobile: 'none', desktop: 'flex' }}
        >
          {ROUTES.map(({ name, path }) => (
            <StyledLink key={name} to={path}>
              {name}
            </StyledLink>
          ))}
          <Button.Outlined
            fontSize="s"
            onClick={() => scrollIntoView('rent-form')}
          >
            SEE IF YOU QUALIFY
          </Button.Outlined>
        </Flex>
        <Flex flex="none" display={{ desktop: 'none' }} m={`-${space.m}`}>
          <Flex
            justifyContent="center"
            alignItems="center"
            p="m"
            onClick={onMobileMenuButtonClick}
          >
            <HamburgerButton
              open={isMobileMenuOpen}
              width={40}
              height={20}
              strokeWidth={2.5}
              color={COLORS.DARK_SAPHIRE}
              animationDuration={0.3}
            />
          </Flex>
        </Flex>
      </Flex>
    </Container.FullWidth>
  </Layout>
)

Header.propTypes = {
  isMobileMenuOpen: PropTypes.bool.isRequired,
  onMobileMenuButtonClick: PropTypes.func.isRequired,
}

export default Header
